const xss = (value) => {
  const pattern = /^[^?\\:;<>"%$]*$/;
  
  if (!(pattern.test(value))) {
    return 'errors.formFields.crossSiteError';
  }
};

export default xss;
